import styled from 'styled-components';
import { AnchorLink } from '@pearsontechnology/aero-components';

export const ReactCsvDownloadWrapper = styled.div`
  display:none;
`;

export const KnowledgeMapEmptyList = styled.div`
  display:none;
`;

export const ActionsRightWrapper = styled.div`
  display: flex;
  > span {
    margin-right: 15px;
  }
`;

export const DownloadKnowledgeMapLink = styled(AnchorLink)`
  display: none;
`;
